import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { API_tecnicos } from "../../config/apiConfig";
import "../../pages/admin/css/Dashboard.css";

const ProximasCitas = () => {
  const { user, role } = useSelector((state) => state.auth);
  const [citas, setCitas] = useState([]);

  useEffect(() => {
    const fetchCitas = async () => {
      try {
        // 1. Obtener todos los técnicos
        const res = await fetch(`${API_tecnicos}`);
        const data = await res.json();

        // 2. Buscar al técnico logueado
        const tecnico = data.find(
          (t) =>
            t.email === user?.email ||
            (t.name?.toLowerCase() === user?.name?.toLowerCase() && t.role === role)
        );

        if (!tecnico) return;

        // 3. Obtener sus citas
        const resCitas = await fetch(`${API_tecnicos}/${tecnico.id}/citas`);
        const citasData = await resCitas.json();

        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0); // Quita la parte de la hora para comparar bien

        // 4. Filtrar citas aceptadas
        const citasAceptadas = citasData.filter((cita) => cita.state?.toLowerCase() === "aceptado" &&
          new Date(cita.appointmentDate) >= hoy
        );
        // Ordenar por fecha ascendente
        citasAceptadas.sort((a, b) => new Date(a.appointmentDate) - new Date(b.appointmentDate));

        setCitas(citasAceptadas);
      } catch (error) {
        console.error("Error al obtener citas del técnico:", error);
      }
    };

    if (user && role) {
      fetchCitas();
    }
  }, [user, role]);

  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="citas">
      <h1 className="mayusculas">PRÓXIMAS CITAS</h1>
      
      {/* Listado de citas con fecha, usuario y asunto */}
      <div>
        {citas.length > 0 ? (
          citas.map((cita) => (
            <div key={cita.appointmentId} className="proxima-cita column">
              <p className="fecha verde"><strong>{formatearFecha(cita.appointmentDate)}</strong></p>
              <p className="asunto bold mt-5">{cita.name}</p>
              <p className="asunto mb-5">{cita.dni}</p>
              <p className="asunto">{cita.subject}</p>
            </div>
          ))
        ) : (
          <p className="mt-20 mb-20">No tienes citas con usuarios.</p>
        )}
      </div>
      
      <Link to="/admin/agenda" className="boton verde bold">Ver agenda</Link>
    </div>
  );
};

export default ProximasCitas;